import HomePage from "./pages/Home/HomePage";
import HomePageMenu from "./pages/Home/HomePageMenu";
import HomePageMenuVideos from "./pages/Home/HomePageMenuVideos";

import StudioTeam from "./pages/Studio/StudioTeam";
import Job from "./pages/Studio/Job";
import StudioContact from "./pages/Studio/StudioContact";
import StudioMembers from "./pages/Studio/StudioMembers";

import AdminLogIn from "./pages/LogIn/AdminLogIn";
import ResetPassword from "./pages/LogIn/ResetPassword";
import ResetPasswordCode from "./pages/LogIn/ResetPasswordCode";
import ChangePassword from "./pages/LogIn/ChangePassword";
import PasswordChanged from "./pages/LogIn/PasswordChanged";

import AddApartamentsSelectedProjects from "./pages/Apartaments/AddApartamentsSelectedProject";
import AddApartamentsInProgressProject from "./pages/Apartaments/AddApartamentsInProgressProject";
import ApartamentsInProgressProjects from "./pages/Apartaments/ApartamentsInProgressProjects";
import ApartamentsSelectedProjects from "./pages/Apartaments/ApartamentsSelectedProjects";
import HousesSelectedProjects from "./pages/Houses/HousesSelectedProjects";
import AddHousesSelectedProjects from "./pages/Houses/AddHousesSelectedProjects";
import HousesInProgressProjects from "./pages/Houses/HousesInProgressProjects";
import AddHousesInProgressProject from "./pages/Houses/AddHousesInProgressProject";
import ResidentialAndPublicSelectedProjects from "./pages/ResidentialAndPublicProjects/ResidentialAndPublicSelectedProjects";
import AddResidentialAndPublicInProgressProject from "./pages/ResidentialAndPublicProjects/AddResidentialAndPublicInProgressProject";
import AddResidentialAndPublicSelectedProjects from "./pages/ResidentialAndPublicProjects/AddResidentialAndPublicSelectedProjects";
import ResidentialAndPublicInProgressProjects from "./pages/ResidentialAndPublicProjects/ResidentialAndPublicInProgressProjects";
import LandscapeSelectedProjects from "./pages/Landscape/LandscapeSelectedProjects";
import LandscapeInProgressProjects from "./pages/Landscape/LandscapeInProgressProjects";
import AddLandscapeSelectedProjects from "./pages/Landscape/AddLandscapeSelectedProject";
import AddLandscapeInProgressProject from "./pages/Landscape/AddLandscapeInProgressProject";
import EditApartamentsSelectedProject from "./pages/Apartaments/EditAppartmentsSelectedProject";
import EditHousesSelectedProject from  "./pages/Houses/EditHousesSelectedProject"
import EditResidentialAndPublicSelectedProject from "./pages/ResidentialAndPublicProjects/EditResidentialAndPublicSelectedProject";
import EditLandscapeArchitectureSelectedProject from "./pages/Landscape/EditLandscapeSelectedProjects";
import EditApartamentsInProgress from "./pages/Apartaments/EditApartamentsInProgressProjects";
import EditHousesInProgress from "./pages/Houses/EditHousesInProgressProjects";
import EditResidentialAndPublicInProgress from "./pages/ResidentialAndPublicProjects/EditResidentialAndPublicInProgressProjects";
import EditLandscapeInProgress from "./pages/Landscape/EditLandscapeInProgressProjects";

export const routes = [
  //Auth
  {
    path: "/log-in",
    isExact: true,
    component: AdminLogIn,
  },
  {
    path: "/reset-password",
    isExact: true,
    component: ResetPassword,
  },
  {
    path: "/reset-password-code",
    isExact: true,
    component: ResetPasswordCode,
  },
  {
    path: "/change-password",
    isExact: true,
    component: ChangePassword,
  },
  {
    path: "/password-changed",
    isExact: true,
    component: PasswordChanged,
  },
  //Home Page
  {
    path: "/homepage",
    isExact: true,
    component: HomePage,
  },
  {
    path: "/homepage/menu/pictures",
    isExact: true,
    component: HomePageMenu,
  },
  {
    path: "/homepage/menu/videos",
    isExact: true,
    component: HomePageMenuVideos,
  },
  //Studio
  {
    path: "/studio/team",
    isExact: true,
    component: StudioTeam,
  },
  {
    path: "/studio/members",
    isExact: true,
    component: StudioMembers,
  },
  {
    path: "/studio/jobs",
    isExact: true,
    component: Job,
  },
  {
    path: "/studio/contact",
    isExact: true,
    component: StudioContact,
  },
  //Apartaments
  {
    path: "/apartment/selected-projects",
    isExact: true,
    component: ApartamentsSelectedProjects,
  },
  {
    path: "/apartment/add-selected-project",
    isExact: true,
    component: AddApartamentsSelectedProjects,
  },
  {
    path: "/apartment/in-progress-projects",
    isExact: true,
    component: ApartamentsInProgressProjects,
  },
  {
    path: "/apartment/add-in-progress-project",
    isExact: true,
    component: AddApartamentsInProgressProject,
  },
  {
    path: "/apartment/edit-selected-projects-project/:id",
    isExact: true,
    component: EditApartamentsSelectedProject,
  },
  {
    path: "/apartment/edit-in-progress-project/:id",
    isExact: true,
    component: EditApartamentsInProgress,
  },
  //Houses
  {
    path: "/houses/selected-projects",
    isExact: true,
    component: HousesSelectedProjects,
  },
  {
    path: "/houses/add-selected-project",
    isExact: true,
    component: AddHousesSelectedProjects,
  },
  {
    path: "/houses/in-progress-projects",
    isExact: true,
    component: HousesInProgressProjects,
  },
  {
    path: "/houses/add-in-progress-project",
    isExact: true,
    component: AddHousesInProgressProject,
  },
  {
    path: "/houses/edit-selected-projects-project/:id",
    isExact: true,
    component: EditHousesSelectedProject,
  },
  {
    path: "/houses/edit-in-progress-project/:id",
    isExact: true,
    component: EditHousesInProgress,
  },

  // //Residential
  {
      path:"/residential-and-public/selected-projects",
      isExact:true,
      component:ResidentialAndPublicSelectedProjects
  },
  {
      path:"/residential-and-public/in-progress-projects",
      isExact:true,
      component:ResidentialAndPublicInProgressProjects
  },
  {
      path:"/residential-and-public/add-selected-project",
      isExact:true,
      component:AddResidentialAndPublicSelectedProjects
  },
  {
      path:"/residential-and-public/add-in-progress-project",
      isExact:true,
      component:AddResidentialAndPublicInProgressProject
  },
  {
      path:"/residential-and-public/edit-selected-projects-project/:id",
      isExact:true,
      component:EditResidentialAndPublicSelectedProject
  },
  {
    path: "/residential-and-public/edit-in-progress-project/:id",
    isExact: true,
    component: EditResidentialAndPublicInProgress,
  },
  // //Landscape
  {
      path:"/landscape-architecture/selected-projects",
      isExact:true,
      component:LandscapeSelectedProjects
  },
  {
      path:"/landscape-architecture/add-selected-project",
      isExact:true,
      component:AddLandscapeSelectedProjects
  },
  {
      path:"/landscape-architecture/in-progress-projects",
      isExact:true,
      component:LandscapeInProgressProjects
  },
  {
      path:"/landscape-architecture/add-in-progress-project",
      isExact:true,
      component:AddLandscapeInProgressProject
  },
  {
      path:"/landscape-architecture/edit-selected-projects-project/:id",
      isExact:true,
      component:EditLandscapeArchitectureSelectedProject
  },
  {
      path:"/landscape-architecture/edit-in-progress-project/:id",
      isExact:true,
      component:EditLandscapeInProgress
  },
];
